<!-- ReferEarnIcon.vue -->
<template>
  <svg :class="iconClass" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <!-- Gift box base -->
    <rect 
      x="4" 
      y="10" 
      width="16" 
      height="11" 
      rx="1" 
      stroke="#333333" 
      stroke-width="1.5" 
      stroke-miterlimit="10" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
    
    <!-- Gift box lid -->
    <path 
      d="M3 10 L21 10 L21 8 C21 7.44772 20.5523 7 20 7 L4 7 C3.44772 7 3 7.44772 3 8 L3 10 Z" 
      stroke="#333333" 
      stroke-width="1.5" 
      stroke-miterlimit="10" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
    
    <!-- Ribbon vertical -->
    <line 
      x1="12" 
      y1="7" 
      x2="12" 
      y2="21" 
      stroke="#333333" 
      stroke-width="1.5" 
      stroke-linecap="round"
    />
    
    <!-- Ribbon horizontal -->
    <line 
      x1="3" 
      y1="10" 
      x2="21" 
      y2="10" 
      stroke="#333333" 
      stroke-width="1.5" 
      stroke-linecap="round"
    />
    
    <!-- Bow left -->
    <path 
      d="M12 7 C10 7 8 5 8 3 C8 4 6 5 4 5" 
      stroke="#333333" 
      stroke-width="1.5" 
      stroke-miterlimit="10" 
      stroke-linecap="round" 
      stroke-linejoin="round" 
      fill="none"
    />
    
    <!-- Bow right -->
    <path 
      d="M12 7 C14 7 16 5 16 3 C16 4 18 5 20 5" 
      stroke="#333333" 
      stroke-width="1.5" 
      stroke-miterlimit="10" 
      stroke-linecap="round" 
      stroke-linejoin="round" 
      fill="none"
    />
    
    <!-- Dollar/Pound symbol inside gift -->
    <text 
      x="12" 
      y="17" 
      font-size="6" 
      font-weight="bold" 
      fill="#333333" 
      text-anchor="middle" 
      dominant-baseline="middle"
    >£</text>
  </svg>
</template>

<script setup>
defineProps({
  iconClass: {
    type: String,
    default: '',
  }
});
</script>